import { PositioningTypes } from 'src/services/widgets/types';
import { LabelingTypeEnum } from 'src/types';
import { AlarmPriority } from 'src/types/alarms';
import { UserDefinedValue } from 'src/types/controllers/controller';

export enum SiteType {
  lift_station = 'lift_station',
  water_treatment_plant = 'water_treatment_plant',
  wastewater_treatment_plant = 'wastewater_treatment_plant',
  booster_pump_station = 'booster_pump_station',
  water_tower = 'water_tower',
  process_plant = 'process_plant',
  combined_sewage_overflow = 'combined_sewage_overflow',
  water_well = 'water_well',
}

export type Location = {
  street?: string;
  city: string;
  country?: string;
  state: string;
  zip?: string;
  altitude?: string;
  longitude?: string;
  latitude?: string;
  timeZone?: string;
};

export enum WidgetDataTypeEnum {
  DAILY_CYCLE_COUNT = 'CYCLE_COUNT',
  RUNTIME = 'RUNTIME',
  LIVE_DATA = 'LIVE_DATA',
}

export enum WidgetTypeEnum {
  TOWER = 'WATER_TOWER',
  LIFT_STATION_WET_WELL = 'WET_WELL',
  PUMP = 'PUMP',
  BARS_GRAPH = 'BARS_GRAPH',
  SPIRAL_GRAPH = 'SPIRAL_GRAPH',
  LINEAR_GRAPH = 'LINEAR_GRAPH',
  SPIRAL_DOTS_GRAPH = 'SPIRAL_DOTS_GRAPH',
  CONTROLLER_WIDGET = 'CONTROLLER_WIDGET',
  VALVE = 'VALVE',
  LIVE_DATA = 'LIVE_DATA',
  LIFT_STATION_WIDGET = 'LIFT_STATION',
  ASSET_CONTROLLER = 'ASSET_CONTROLLER',
}

export enum WidgetSubTypeEnum {
  PUMP_1 = 'PUMP_1',
  PUMP_2 = 'PUMP_2',
  PUMP_3 = 'PUMP_3',
  VALVE = 'VALVE',
  VALVE_1 = 'VALVE_1',
  VALVE_2 = 'VALVE_2',
  WET_WELL_1 = 'WET_WELL_1',
  VALVE_3 = 'VALVE_3',
}

export type WidgetType = {
  connectedTo: string | any;
  title?: string;
  createdAt: string;
  id: string;
  positioning: PositioningTypes;
  updatedAt: string;
  widgetType: WidgetTypeEnum;
  widgetSubType?: string;
  widgetDataType?: string;
  tags?: { id: string; position: number }[];
};

export type AssignedTag = {
  tagIndicatorValue: string;
  tagIndicatorPosition: number;
  id: string;
  tagName: string;
  alarmTagName?: string;
  assignedTagId?: string;
  assignedGatewayId: string;
  tagIndicator: string;
};

export type AssetProperty = {
  id?: string;
  name?: string;
  unit?: string;
  value?: string;
};

export type AssignedAlarmTag = {
  id: string;
  alarmTagName: string;
  assignedAlarmGatewayId: string | null;
  assignedAlarmTagId: null;
  level: number;
  assignedTagId: string;
};

export type AssetType = {
  assetName: string;
  assetProperties?: AssetProperty[];
  assetType: string;
  assignedAlarmTags?: AssignedAlarmTag[];
  assignedTags?: AssignedTag[];
  createdAt: string;
  id: string;
  updatedAt: string;
  priority: AlarmPriority;
};

export type DailyRuntime = {
  day: string;
  value: number;
};

export type DailyCycleCount = {
  day: string;
  value: number;
};

type ConnectedToAsset = {
  assetId: string;
  assetType: string;
  assignedTagLabel: string;
};

export type TagType = {
  alarm: AlarmPriority;
  connectedToAssets: ConnectedToAsset[];
  advancedTagMapping: {
    userDefinedValues: UserDefinedValue[];
  };
  dataType: string | null;
  displayName: string;
  gatewayId: string;
  rawUnit: string | null;
  tagId: string;
  value: number | string | null;
  position?: number;
  id?: string;
  labellingType: LabelingTypeEnum;
  fallbackValue: string;

  indicator?:
    | 'StateOn'
    | 'StateOff'
    | 'AlarmOn'
    | 'AlarmOff'
    | 'Info'
    | 'Warning'
    | 'Critical'
    | 'Cleared'
    | 'Offline'
    | null;
};

export type TagsTypes = {
  siteId: string;
  tags: TagType[];
  showLiveData: boolean;
};
